import React from "react";
import Image from "./Image";
import { GameContext } from "../../context/GameContext";

function ImageContainer() {
  const {
    questionsArray,
    setCurrentQuestion,
    deskQuest,
    setDeskQuest,
    checkAlreadyAnswerd,
  } = React.useContext(GameContext);

  const getId = (id, e) => {
    if (e.target.dataset.name) {
      setCurrentQuestion(id);
      checkAlreadyAnswerd(id);
      setDeskQuest(!deskQuest);
    }
  };

  return (
    <>
      <div className="ref"></div>
      <div className="main">
        {questionsArray.map((obj) => (
          <Image key={obj.id} obj={obj} onClick={getId} />
        ))}
      </div>
    </>
  );
}

export default ImageContainer;
